import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoaderModule, TranslateModule } from '@xref/ngx';
import { OauthOpenApiComponent } from './oauth-open-api.component';
import { OauthConnectModule } from 'src/app/components/oauth-connect/oauth-connect.module';

@NgModule({
    imports: [
        CommonModule,
        LoaderModule,
        TranslateModule,
        OauthConnectModule
    ],
    declarations: [OauthOpenApiComponent]
})
export class OauthOpenApiModule {}
